/* eslint-disable react/display-name */
import { useState, useContext, useEffect } from "react";
import { Paper, Grid, Alert, AlertTitle } from "@mui/material";
import QRCode from "react-qr-code";

import { NexcalEmployeeLogo, PhcsLogo, BOPPanhandleFirstBankLogo } from "../../../../../assets";
import { AuthContext } from "../../../../../contexts";
import { maskSSN } from "../../../../../constants/maskSSN";
import { getLocalIPV4 } from "../../../../../utils/commonFunctions/getLocalIP4";
import encryption from "../../../../../utils/commonFunctions/encryption";
import { MEMBER_ENV } from "../../../../../config/config";
import { HealthCardAlert } from "../../../../shared";
import BOPAlertCaution from "../BOPAlertCaution/BOPAlertCaution";

// import "./dentalCardStyles.css";

interface IVisionPlanCardProps {
	hasVisionPlan: boolean;
}
/* eslint-disable react/prop-types */
const VisionPlanCardPanhanle: React.FC<IVisionPlanCardProps> = ({ hasVisionPlan }) => {
	const [localIP, setLocalIP] = useState("");
	const [urlLink, setUrlLink] = useState("");
	const { member } = useContext(AuthContext);

	// console.log("Member Details", member);
	const _ssn = maskSSN(member?.SSN);

	useEffect(() => {
		// eslint-disable-next-line arrow-parens
		getLocalIPV4().then((ip) => setLocalIP(ip));
	}, []);

	useEffect(() => {
		const { group_number, date_of_birth, SSN } = member;

		if (member && localIP) {
			const localRedirectionLink = `http:${localIP}:3002/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			const prodRedirectionLink = `www.nexcaliber.com/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			if (member && MEMBER_ENV === "LOCAL") setUrlLink(localRedirectionLink);
			if (member && (MEMBER_ENV === "PROD" || MEMBER_ENV === "DEV")) setUrlLink(prodRedirectionLink);
		}
	}, [member, localIP]);

	if (!member) {
		return <div>Loading member details...</div>;
	}

	// const _ssn = maskSSN(member?.SSN);
	return (
		<div>
			<div style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
				{!hasVisionPlan && <BOPAlertCaution planName="Vision Plan" />}
			</div>
			<div
				className="employee-id-card-frontside-container card-content"
				style={{
					filter: hasVisionPlan ? "none" : "blur(5px)",
					pointerEvents: hasVisionPlan ? "auto" : "none" // Prevent interaction with blurred content
				}}
			>
				<div className="paper-form-container">
					<Paper className="theme-border-radius emp-paper-container" elevation={1}>
						<div style={{ textAlign: "center", position: "relative" }}>
							<h3 style={{ marginBottom: 0, fontSize: "15px", fontWeight: 900, color: "black" }}>
								Panhandle First Bank
							</h3>
							<h4 style={{ textDecoration: "underline", marginTop: 0, fontSize: "12px" }}>VISION PLAN</h4>
							<p style={{ marginTop: -18, fontSize: "10px" }}>Administered by Nexcaliber</p>
							<div>
								<QRCode
									size={256}
									style={{
										position: "absolute",
										right: "5px",
										top: "50%",
										transform: "translateY(-50%)",
										width: "4rem",
										height: "auto"
									}}
									value={urlLink}
									fgColor="#4e4e4e"
									bgColor="#ffffff"
								/>
								<div
									className="corner-border top-left"
									style={{
										position: "absolute",
										top: "-14px",
										left: "327px",
										width: "10px",
										height: "10px",
										borderTop: "2px solid #9c27b0",
										borderLeft: "2px solid #9c27b0"
									}}
								></div>
								<div
									className="corner-border top-right"
									style={{
										position: "absolute",
										top: -14,
										right: 0,
										width: "11px",
										height: "11px",
										borderTop: "2px solid #9c27b0",
										borderRight: "2px solid #9c27b0"
									}}
								></div>
								<div
									className="corner-border bottom-left"
									style={{
										position: "absolute",
										bottom: -14,
										left: 327,
										width: "11px",
										height: "11px",
										borderBottom: "2px solid #9c27b0",
										borderLeft: "2px solid #9c27b0"
									}}
								></div>

								{/* Bottom-right corner border */}
								<div
									className="corner-border bottom-right"
									style={{
										position: "absolute",
										bottom: -14,
										right: 0,
										width: "11px",
										height: "11px",
										borderBottom: "2px solid #9c27b0",
										borderRight: "2px solid #9c27b0"
									}}
								></div>
								<span
									style={{
										display: "block",
										fontSize: "9px",
										color: "black",
										textAlign: "right",
										position: "absolute",
										right: "0px",
										top: "calc(50% + 3rem)",
										transform: "translateY(-50%)"
									}}
								>
									Scan for Eligibility <br />
									<span style={{ marginRight: "8px" }}>and benefits</span>
								</span>
							</div>
						</div>

						<Grid container className="employee-middle-section-container">
							<div className="employee-detail" style={{ fontSize: "11px" }}>
								Employee ID Number : XXXX-XX-{maskSSN(member.SSN)}
							</div>
							<span style={{ fontSize: "9px" }}>
								This card is for identification only; it does not guarantee benefit payment
							</span>
							<div className="employee-detail" style={{ fontSize: "11px", marginTop: -4 }}>
								Employee Name : {member.last_name}, {member.first_name}
							</div>
						</Grid>
						<div className="border-seperator" />
						<Grid container className="employee-card-front-footer">
							<div>
								<h1
									style={{
										fontSize: "15px",
										margin: "0",
										textDecoration: "underline",
										textAlign: "center"
									}}
								>
									VISION Plan Benefits
								</h1>
								<div style={{}}>
									<strong>Provider Network:</strong>
									<span style={{ marginLeft: 30 }}>No network any dental provider can be used</span>
								</div>
								<div>
									<strong>Examination:</strong>
									<span style={{ marginLeft: 30 }}>$10 copay</span>
								</div>
								<div>
									<strong>Frames:</strong>
									<span style={{ marginLeft: 30 }}>100% up to $70 / 1 per year</span>
								</div>

								<div>
									<strong>Lenses:</strong>
									<span style={{ marginLeft: 30 }}>100% up to limited benefit / 1 per year</span>
									<span style={{ display: "block", fontSize: "12px", color: "gray", marginTop: 5 }}>
										For all other benefits please contact Nexcaliber
									</span>
								</div>
							</div>
						</Grid>
					</Paper>
				</div>
			</div>
			<div
				className="employee-id-card-backside-container card-content"
				style={{
					filter: hasVisionPlan ? "none" : "blur(5px)",
					pointerEvents: hasVisionPlan ? "auto" : "none"
				}}
			>
				<div className="paper-form-container">
					<Paper className="theme-border-radius emp-paper-container" elevation={1}>
						<div className="card-back-topPortion-container">
							<span style={{ fontWeight: "900", fontSize: "15px", marginBottom: 12, color: "black" }}>
								For online claim access
							</span>
							<span style={{ fontWeight: 900 }}>
								Webpage address is https://member.enrollment.nexcaliber.com
							</span>
						</div>

						<div className="footer-border" />

						<div className="card-back-midPortion-container">
							<div className="upper-section">
								<span style={{ fontWeight: "bold", marginTop: "0.8rem" }}>
									Vision / Enrollment Questions and Verification
								</span>
								<br />
								<span style={{ fontWeight: "bold" }}>Nexcaliber: (800) 741-0185</span>
							</div>
							<div className="footer-border" />

							{/* <div className="footer-top-content-container" style={{ padding: "0.2rem" }}>
								<span
									className="footer-top-sub-content"
									style={{ marginLeft: "4px", fontSize: "0.65rem" }}
								>
									For Assistance locating a PRO provider, call Nexcaliber: (800) 741-0185
								</span>
							</div> */}
						</div>

						{/* <div className="footer-border" /> */}

						<div className="summary-benefits-footer-container">
							<div className="footer-bottom-content" style={{ marginTop: "0.8rem" }}>
								Mail all claims to Nexcaliber
								<br />
								<span>PO Box 802422, Dallas, Texas 75380</span>
							</div>
							<div className="footer-logo-container">
								<img src={NexcalEmployeeLogo} alt="Nexcal employee Logo" />
							</div>

							{/* <div className="footer-content" style={{ marginLeft: "-0.2rem" }}>
								Medical and Dental Benefit / Enrollment Questions and Verifications : Call Nexcaliber
								(800) 741-0185
							</div> */}
						</div>
					</Paper>
				</div>
			</div>
		</div>
	);
};

export default VisionPlanCardPanhanle;
